import React, { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';
import { userActivation } from 'store/AdminClient/CLientAdminManagement';

import axiosPrivate from 'config/axiosPrivate';

import { ROLES } from 'utils/Constants';
import ErrorSuccesModal from 'components/shared/modal/ErrorSuccesModal';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import { useTranslation } from 'react-i18next';

export const DisableUser = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [errorSuccess, setErrorSuccess] = useState(false);
  const [errorSuccessMsg, setErrorSuccessMsg] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const [confirmation, setConfirmation] = useState(false);
  const [confirmationMsg, setConfirmationMsg] = useState('');

  const [role, setRole] = useState('');

  useEffect(() => {
    switch (props.selected?.role) {
      case ROLES.ADMIN_CLIENT:
        setRole(t("l'admin"));
        break;
      case ROLES.GLOBAL_WRITER:
        setRole(t('le rédacteur'));
        break;
      case ROLES.PROJECT_MANAGER:
        setRole(t('Le chef de projet'));
        break;
      case ROLES.WRITER:
        setRole(t('le rédacteur'));
        break;
      default:
        setRole(t(`L'utilisateur`));
        break;
    }

    setConfirmation(true);
  }, [props.selected, t]);

  useEffect(() => {
    if (props.selected.user.active) {
      setConfirmationMsg(
        `${t('Voulez-vous vraiment désactiver')} ${t(role)} ${
          props.selected?.user.mail
        } ?`
      );
    } else {
      setConfirmationMsg(
        `${t('Voulez-vous vraiment activer')} ${t(role)} ${
          props.selected?.user.mail
        } ?`
      );
    }
  }, [role, props.selected, t]);

  const disableUser = () =>
    axiosPrivate
      .put('/user/external/activation', null, {
        params: { mail: props.selected.user.mail },
      })
      .then(() => {
        setConfirmation(false);
        dispatch(
          userActivation({
            mail: props.selected.user.mail,
            key: 'active',
            value: props.selected.user.active,
          })
        );
        setIsSuccess(true);
        if (props.selected.user.active) {
          setErrorSuccessMsg(
            `${t(role)} ${props.selected.user.mail} ${t(
              'a été désactivé avec succès'
            )} ?`
          );
        } else {
          setErrorSuccessMsg(
            `${t(role)} ${props.selected.user.mail} ${t(
              'a été activé avec succès'
            )} ?`
          );
        }

        setErrorSuccess(true);
      })
      .catch((e) => {
        setConfirmation(false);
        setIsSuccess(false);
        setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
        setErrorSuccess(true);
      });

  return (
    <div>
      <ErrorSuccesModal
        open={errorSuccess}
        message={errorSuccessMsg}
        handleClose={() => setErrorSuccess(false)}
        success={isSuccess}
        toggle={() => setErrorSuccess(!errorSuccess)}
      />

      <ConfirmationModal
        open={confirmation}
        message={confirmationMsg}
        handleClose={() => props.Close()}
        executeAction={() => {
          disableUser();
        }}
      />
    </div>
  );
};
